import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import TrialFormComponent1 from './components/trial-form';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Success1 from './components/success2';
import SalesforceAuth from './components/salesforce/auth';
import zipy from 'zipyai';
import { ZIPPY_ENVS, zipy_sdk_key } from './utils/common';
import Verification from './components/verification/Verification';
import Support from './components/support/support';
import InstallPackage from './components/appexchange/install-package';

const disableLog = () => {
  const PROD_ENVS = ["production", "aus_production", "eu_production"]
  if (PROD_ENVS.includes(process.env.REACT_APP_ENV)) {
    console.log = () => {}
    console.error = () => {}
    console.debug = () => {}
  }
}

const initzipy = () => {
  if (ZIPPY_ENVS.includes(process.env.REACT_APP_ENV)) {
    console.log('ZIPPY_ENVS::', ZIPPY_ENVS, zipy_sdk_key);
    zipy.init(zipy_sdk_key);
  }
}

disableLog();
initzipy();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router basename='/trial'>
      <Routes>
        <Route path="/" element={<TrialFormComponent1/>}/>
        <Route path="/success" element={<Success1/>}/>
        <Route path="/salesforce/authorize" element={<SalesforceAuth/>}/>
        <Route path="/verification" element={<Verification/>}/> 
        <Route path="/support" element={<Support/>}/>
      </Routes>
    </Router>
    <Router basename='/salesforce/setup'>
      <Routes>
        <Route path="/" element={<InstallPackage/>}/>
      </Routes>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
